import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["addressSection", "pointsSection", "schoolsSection"];

  static values = {
    noteMaxLength: { type: Number, default: 100 },
  };

  connect() {
    this.sections = [
      this.addressSectionTarget,
      this.pointsSectionTarget,
      this.schoolsSectionTarget,
    ];
  }

  showAddress() {
    this.showOnly(this.addressSectionTarget);
  }

  showPoints() {
    this.showOnly(this.pointsSectionTarget);
  }

  showSchools() {
    this.showOnly(this.schoolsSectionTarget);
  }

  showOnly(visibleSection) {
    this.sections.forEach((section) => {
      section.hidden = section !== visibleSection;
    });
  }

  selectPoint(event) {
    const li = event.currentTarget;
    const id = li.getAttribute("id") || "";
    const match = id.match(/^(pick-up|school-pick-up)-points-(\d+)$/);
    if (!match) return;
    const [, prefix, pointId] = match;
    const isSchool = prefix === "school-pick-up";

    const schoolField = this.element.querySelector('input[name*="pick_up_high_school_id"]');
    const pointField = this.element.querySelector('input[name*="pick_up_pick_up_point_id"]');
    if (schoolField) schoolField.value = isSchool ? pointId : "";
    if (pointField) pointField.value = isSchool ? "" : pointId;

    this.element.querySelectorAll("[id^='pick-up-points-'], [id^='school-pick-up-points-']").forEach((el) => {
      el.classList.remove("Panel--subtle");
      if (el.getAttribute("id") !== id) el.classList.add("Panel--subtle");
    });
  }

  updateNoteCounter(event) {
    const maxLength = this.noteMaxLengthValue;
    const length = event.target.value.length;
    const counterEl = document.getElementById(event.target.dataset.counterId);

    if (!counterEl) return;

    counterEl.textContent = `${length}/${maxLength}`;
    counterEl.classList.toggle("u-textRed", length > maxLength);
  }
}
